<template>
  <!-- component -->
  <!-- Toast Container -->
  <!-- put taost notification in here , to cope when the toast more than one -->
  <!-- class="" For put toast on top right -->
  <div  class="flex flex-col justify-center fixed left-0 top-0 sm:top-auto sm:bottom-0 pt-1 pb-5 px-5 w-full max-w-full sm:max-w-xs z-50">
    <transition-group tag="div" name="slide-left" >
      <section v-for="(notification, index) in notifications" :key="notification.id" class="border-l-4  pt-1 sm:pt-3 shadow-md mb-1 sm:mb-2 transition-all cursor-pointer transform hover:scale-105 rounded-md bg-opacity-90" @click="stopToast(notification.id)" @mouseenter="pauseTimer(index)" @mouseleave="pauseTimer(index,false)" :class="[ 'bg-' + getNotifStatusColor(notification.status) + '-500', 'border-' + getNotifStatusColor(notification.status) + '-600' ]" >
      
      <div class="w-full">
        <section class="flex items-center  px-5">
          <!-- icons -->
          <div class="mr-3 ">

            <div class="w-10 sm:w-12 h-10 sm:h-12 flex rounded-lg bg-white text-3xl sm:text-4xl" :class="[ 'text-' + getNotifStatusColor(notification.status) + '-500' ]">
              <span v-if="notification.status === 'success'" class="table m-auto"><ion-icon name="checkmark-done-outline" ></ion-icon></span>

              <span v-else-if="notification.status === 'warning'" class="table m-auto"><ion-icon name="alert-outline" ></ion-icon></span>

              <span v-else-if="notification.status === 'danger'" class="table m-auto"><ion-icon name="bug-outline" ></ion-icon></span>  

              <span v-else-if="notification.status === 'info'" class="table m-auto"><ion-icon name="information-outline" ></ion-icon></span>   
            </div>
            
          </div>
          
          <!-- message -->
          <div class="text-white text-sm sm:text-md max-w-full break-words">
            <h6>{{notification.message}}</h6>
          </div>
        </section>
        <section class="mt-1 sm:mt-3">
          <div class="pt-2 pl-1">
            <div class="h-1 rounded-full w-0" :style="{'animation-duration': notification.time + 'ms'}" :class="[notification.timerLineWidth, 'bg-' + getNotifStatusColor(notification.status) + '-800' ]" ></div>
          </div>
        </section>
      </div>
      </section>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "Notification",
  data() {
      return {
        notifications: []
      }
  },
  methods: {
    decrementTimer(index){
      if(!this.notifications[index])return;
      this.notifications[index].timerLineWidth = "decrement-width";
      const idToRemove = this.notifications[index].id;
      this.notifications[index].timeStart = Date.now();
      this.notifications[index].timer = setTimeout(() => this.stopToast(idToRemove) , this.notifications[index].time);
    },
    startToast(status, message, time = 5000){
      let newNotification = {
        'id' : this.availableId,
        'status' : status,
        'message' : message,
        'timerLineWidth' : "pause-animation", // timer width behavior class
        'timer' : null, //setTimeOut instance
        'time' : time,
        'timeStart' : 0 //flag when the notification timer start
      }
      this.notifications.push(newNotification) - 1;
      const newNotificationIndex = this.notifications.length - 1;
      this.decrementTimer(newNotificationIndex);
    },
    stopToast(id = null){
      for(var i = 0; i < this.notifications.length; i ++){
        if(this.notifications[i].id === id)this.notifications.splice(i, 1);
      }
    },
    pauseTimer(index, toPause = true){
      if(toPause){
        clearTimeout(this.notifications[index].timer);
        this.notifications[index].timerLineWidth += " pause-animation";
        this.notifications[index].time -=  Date.now() - this.notifications[index].timeStart;
        return;
      }
      this.decrementTimer(index);
    },
    getNotifStatusColor(status){
      let notificationColor = "blue"
      switch (status) {
        case 'success':
          notificationColor = "green";
          break;

        case 'info':
          notificationColor = "blue";
          break;
        case 'warning':
          notificationColor = "yellow";
          break;
        case 'danger':
          notificationColor = "red";
          break;
        default:
          break;
      }
      return notificationColor;
    },
  },
  computed: {
    availableId(){
      return this.notifications.length + 1;
    }
  },
  watch : {
    notifications(){
      this.availableId++;
    },
  }
}
</script>

<style>
  .slide-left-enter-active,
  .slide-left-leave-active {
    transition: all 500ms ease;
  }

  .slide-left-enter-from,
  .slide-left-leave-to {
    opacity: 0;
    transform: translateX(-50%);
    
  }

  .decrement-width {
    animation-name: decrementWidth;
    transition: all linear;
  }

  .pause-animation {
    animation-play-state: paused;
  }

  @keyframes decrementWidth{
    from {width: 100%;}
    to {width: 0px;}
  }
</style>